<template>
    <!-- https://www.svgrepo.com/svg/427069/hidden?edit=true -->
    <svg width="20px" height="20px" viewBox="0 -0.94 67.89 67.89" xmlns="http://www.w3.org/2000/svg" fill="#000000">
        <g id="SVGRepo_bgCarrier" stroke-width="0" />

        <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round" />

        <g id="SVGRepo_iconCarrier">
            <g id="Group_3" data-name="Group 3" transform="translate(-480.94 -158.439)">
                <line
                    id="Line_1"
                    data-name="Line 1"
                    y1="55.98"
                    x2="55.98"
                    transform="translate(486.895 159.5)"
                    fill="none"
                    stroke="#814dff"
                    stroke-miterlimit="10"
                    stroke-width="3"
                />
                <path
                    id="Path_9"
                    data-name="Path 9"
                    d="M547.33,197.49c0,9.84-18.39,25.45-32.44,25.45s-32.45-15.61-32.45-25.45,18.39-25.45,32.45-25.45S547.33,187.65,547.33,197.49Z"
                    fill="none"
                    stroke="#F09A0FFF"
                    stroke-linecap="round"
                    stroke-miterlimit="10"
                    stroke-width="3"
                    opacity="0.15"
                />
                <path
                    id="Path_10"
                    data-name="Path 10"
                    d="M547.33,187.49c0,9.84-18.39,25.45-32.44,25.45s-32.45-15.61-32.45-25.45,18.39-25.45,32.45-25.45S547.33,177.65,547.33,187.49Z"
                    fill="none"
                    stroke="#F09A0FFF"
                    stroke-linecap="round"
                    stroke-miterlimit="10"
                    stroke-width="3"
                />
                <circle
                    id="Ellipse_2"
                    data-name="Ellipse 2"
                    cx="11.954"
                    cy="11.954"
                    r="11.954"
                    transform="translate(502.931 185.536)"
                    fill="none"
                    stroke="#F09A0FFF"
                    stroke-linecap="round"
                    stroke-miterlimit="10"
                    stroke-width="3"
                    opacity="0.15"
                />
                <circle
                    id="Ellipse_3"
                    data-name="Ellipse 3"
                    cx="11.954"
                    cy="11.954"
                    r="11.954"
                    transform="translate(502.931 175.536)"
                    fill="none"
                    stroke="#F09A0FFF"
                    stroke-miterlimit="10"
                    stroke-width="3"
                />
            </g>
        </g>
    </svg>
</template>

<script>
export default {
    name: "NewHiddenIcon",
};
</script>

<style scoped></style>
